module.exports = __webpack_public_path__ + "static/media/02.08f1e5f1.gif";